import { useCallback } from 'react';
import { appendParams, finalizeUrl, getDefaultDeeplink } from '../utils';
import { useOpenDeeplink } from '../../../hooks';

type moveToMarketHomeProps = {
  sno: number;
  categorySno?: number | null;
  showCoupons?: boolean;
  order?: string | null;
};

export const useMarketNavigator = () => {
  const { openDeeplink } = useOpenDeeplink();

  const moveToMarketHome = useCallback(
    ({
      sno,
      categorySno = null,
      showCoupons = false,
      order = null,
    }: moveToMarketHomeProps) => {
      const url = getDefaultDeeplink();
      appendParams(url, 'screen', 'MarketHome');
      appendParams(
        url,
        'extras',
        JSON.stringify({
          category_sno: categorySno,
          show_coupons: showCoupons,
          order,
          sno,
        }),
      );
      openDeeplink(finalizeUrl(url));
    },
    [openDeeplink],
  );

  return {
    moveToMarketHome,
  };
};
